import { render, staticRenderFns } from "./FooterHomeEight.vue?vue&type=template&id=6d08a3a6"
import script from "./FooterHomeEight.vue?vue&type=script&lang=js"
export * from "./FooterHomeEight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports